(function () {

  'use strict';

  angular
    .module('specsguardApp')
    .directive('sgMaps', sgMaps);

  function sgMaps () {

    return {
      templateUrl: 'app-legacy/components/sg-maps/sg-maps.html',
      restrict: 'E',
      replace: true,
      link: function (scope, element, attrs) {
        
        element.css('min-height', '200px');

        if (attrs.height) {
          element.css('height', attrs.height);
        }

        const defaults = {
          position: {
            lat: 52.37,
            lng: 4.89
          },
          zoom: 5
        };

        let position = {
          lat: attrs.lat && +attrs.lat,
          lng: attrs.lng && +attrs.lng
        };

        let zoom = attrs.zoom || 17;

        if (isNaN(attrs.lat) || !attrs.lat || isNaN(attrs.lng) || !attrs.lng) {
          position = null;
        }

        // @ts-ignore
        const map = new google.maps.Map(element[0], {
          zoom: position ? zoom : defaults.zoom,
          center: position || defaults.position
        });

        // @ts-ignore
        new google.maps.Marker({
          position: position || defaults.position,
          map: map
        });

      }
    };
  };

})();
